import { Component, OnInit } from '@angular/core';

import { Menu } from 'src/app/core/models/menu';
import { SidebarService } from 'src/app/core/services/sidebar/sidebar.service';

@Component({
  selector: 'shared-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {

  public sidebar: Menu[] = [];

  constructor(
    private readonly _sidebarService: SidebarService
  ) {}

  ngOnInit(): void {
    this.sidebar = this._sidebarService.sidebar;
  }

  get isCollapsed(): boolean {
    return this._sidebarService.isCollapsed;
  }

  /**
   * Event handler to show o hide sidebar.
   */
  public toggleSidebar(): void {
    this._sidebarService.toggleSidebar();
  }
}